import { Card, CardContent, CardProps } from '@material-ui/core';
import { CardTitleTypography } from 'framework/components/CardTitleTypography';
import { DividerWithMargin } from 'framework/components/DividerWithMargin';
import { isLast } from 'framework/utils/array/isLast';
import { ILoan } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { LoanLineListItem } from './LoanLineListItem';

interface IProps extends CardProps {
	item: ILoan;
	reload: VoidFunction;
}

export const LoanDetailsContentCard = ({ item, reload, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<Card {...rest}>
			<CardContent>
				<CardTitleTypography
					title={strings.contents}
					style={{ marginBottom: 8 }}
				/>
				<DividerWithMargin />
				{item.lines.map(t => (
					<LoanLineListItem
						line={t}
						loan={item}
						key={t.id}
						withoutBorder={isLast(t, item.lines)}
					/>
				))}
				{item.lines.length === 0 && <em>{strings.noLinesDefinedYet}</em>}
			</CardContent>
		</Card>
	);
};
